import { useWeb3React } from '@web3-react/core'
import { useTranslation } from 'react-i18next'
import useSWR from 'swr'
import { useUpdaterChainId } from '~/hooks'
import { getXLonBalance } from '~/apis'
import {
  StyledStakingFooter,
  StyledStakingContainer,
  StyledFooterButton,
} from './styled'
import { IFooterButtonProps, IStakingFooterProps } from './types'

const FooterButton: React.FC<IFooterButtonProps> = ({
  children,
  primary,
  inline,
  ...props
}) => {
  const primaryStyle = primary ? 'primary' : ''
  const inlineStyle = inline ? 'inline' : ''
  return (
    <>
      <StyledFooterButton
        className={`${primaryStyle} ${inlineStyle}`}
        {...props}
      >
        {children}
      </StyledFooterButton>
    </>
  )
}

const StakingFooter: React.FC<IStakingFooterProps> = ({
  onRedeem,
  onStake,
}) => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const chainId = useUpdaterChainId()

  const { data: xLonBalance } = useSWR(
    ['getXLonBalance', chainId, account],
    () => getXLonBalance(chainId, account),
  )

  if (!account) return null

  return (
    <StyledStakingFooter>
      <StyledStakingContainer>
        {account && Number(xLonBalance) > 0 && (
          <FooterButton key="redeem" onClick={onRedeem}>
            {t('redeem')}
          </FooterButton>
        )}
        {account && (
          <FooterButton key="stake" primary onClick={onStake}>
            {t('stake')}
          </FooterButton>
        )}
      </StyledStakingContainer>
    </StyledStakingFooter>
  )
}

export default StakingFooter
